import { Component, inject } from '@angular/core';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent {
  private readonly notificationService = inject(NotificationService);

  notificationVisible = this.notificationService.notificationVisible;

  closeNotification() {
    this.notificationService.setNotificationVisible(false);
  }

  ngOnInit() {
    var elems = document.getElementsByTagName('a');
    for (var i = 0; i < elems.length; i++) {
      elems[i].setAttribute('draggable', 'false');
    }
  }
}
